import {FormattedMessage} from 'react-intl'
import {AsideMenuItem} from '../AsideMenuItem'
import {useMenuPermission} from '../../../../helpers/hooks/menuHook'

const ChatsMenu = () => {
  const {filterMenuItems, isMenuItemAllowed} = useMenuPermission()
  return (
    <>
      {isMenuItemAllowed('GENERAL.ASIDE_MENU.CHATS_SECTION') && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-gray-300 fw-bold text-uppercase fs-8 ls-1'>
                <FormattedMessage id='GENERAL.ASIDE_MENU.CHATS_SECTION' />
              </span>
            </div>
          </div>

          {filterMenuItems(menuItems).map((item, index) => (
            <AsideMenuItem
              key={index}
              to={item.to}
              title={item.title}
              fontIcon={item.fontIcon}
              icon={item.icon}
            />
          ))}
        </>
      )}
    </>
  )
}

const menuItems = [
  {
    id: 'email-templates',
    to: '/email-templates',
    title: 'GENERAL.ASIDE_MENU.EMAIL_TEMPLATES_TITLE',
    icon: '/media/icons/duotune/communication/com002.svg',
    fontIcon: 'bi-layers',
  },
  {
    id: 'notification-logs',
    to: '/notifications',
    title: 'GENERAL.ASIDE_MENU.NOTIFICATIONS_TITLE',
    icon: '/media/icons/duotune/communication/com004.svg',
    fontIcon: 'bi-layers',
  },
  {
    to: '/chats',
    title: 'GENERAL.ASIDE_MENU.CHATS_LIST_TITLE',
    fontIcon: 'bi-archive',
    icon: '/media/icons/duotune/communication/com007.svg',
  },
]

export default ChatsMenu
